module.exports = __webpack_public_path__ + "img/hero.4d5e813f.jpg";